import React, { ReactNode } from 'react';
import cc from 'classnames';
import { NavigateBeforeRounded } from '@material-ui/icons';
import Link from '../Link/Link';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './NavigateBack.module.css';

export enum BackThemes {
  link = 'link',
  button = 'button',
}

type Props = {
  to: string,
  children?: ReactNode,
  className?: string,
  theme?: BackThemes,
  onClick?: () => void,
};

const NavigateBack = ({
  to, children, className, theme = BackThemes.link, onClick,
}: Props) => (
  <Link
    to={to}
    className={cc(styles.back, styles[theme], className)}
    onClick={onClick}
  >
    <NavigateBeforeRounded />
    {children}
  </Link>
);

export default NavigateBack;
